
import { combineReducers } from 'redux'
import paginationReducer from './pagination'
import filtersReducer from './filters'

export default combineReducers({
  pagination: paginationReducer,
  filters: filtersReducer
})
